import { faLock, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CardUrl, FieldTypes } from 'types';

import * as styles from './FieldTile.css';

type FieldTileProps = {
  onClick: (type: FieldTypes, subType: CardUrl['type'] | undefined) => void;
  canLock: boolean;
  locked: boolean;
  onLock: (type: string) => void;
  label: string;
  icon: React.ReactElement;
  disabled?: boolean;
} & (
  | {
      type: Exclude<FieldTypes, 'url'>;
      subType?: undefined;
    }
  | {
      type: 'url';
      subType: CardUrl['type'];
    }
);

const FieldTile: React.FC<FieldTileProps> = (props) => {
  const { label, icon, type, subType, onClick, locked, canLock, onLock, disabled = false } = props;

  if (!canLock && locked) {
    return (
      <div className={styles.tile} data-locked="true">
        <div className={styles.tileIcon}>{icon}</div>
        <div className={styles.tileLabel}>{label}</div>
        <div className={styles.tileAction} aria-hidden="true">
          <FontAwesomeIcon icon={faLock} />
        </div>
      </div>
    );
  }

  return (
    <button
      id={`${type}-field-btn`}
      type="button"
      className={styles.tile}
      onClick={() => onClick(type, subType)}
      disabled={disabled}
      data-disabled={disabled}
    >
      <span className={styles.tileIcon}>{icon}</span>
      <span className={styles.tileLabel}>{label}</span>
      <span className={styles.tileAction} aria-hidden="true">
        <FontAwesomeIcon icon={faPlus} />
      </span>
      {canLock && !disabled && (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onLock(subType ?? type);
          }}
          className={styles.lockBtn}
          data-is-locked={locked}
          id={`${type}-lock-btn`}
          aria-label={locked ? 'Unlock field' : 'Lock field'}
        >
          <FontAwesomeIcon icon={faLock} />
        </button>
      )}
    </button>
  );
};

export default FieldTile;
